// extracted by mini-css-extract-plugin
module.exports = {"status":"status","is-live":"is-live","blinker":"blinker"};